<template>
  <div>
    <div v-if="kpiData && kpiData.id">
      <div class="breadcrumb-area pos-relative w-100">
        <!-- title -->
        <div class="row">
          <h5 class="col-sm-6 col-12">UPLOAD THÔNG TIN KPI</h5>
          <div class="col-sm-6 col-12 d-flex justify-content-end align-items-center">
            <!-- <b-button
              v-if="sseData === 100"
              class="ml-2"
              variant="danger"
              @click="onShowSelectDevice('NEW', dataUser.userId, 'DELETE')"
            >
              Hủy
            </b-button>
            <b-button
              class="ml-2"
              variant="primary"
              v-if="canDeviceKpiSendApproveMx && sseData === 100"
              @click="onShowSelectDevice('NEW', dataUser.userId)"
            >
              Gửi duyệt
            </b-button>
            <b-button
              class="ml-2"
              variant="primary"
              v-if="canDeviceKpiMonitorApproveMx && sseData === 100"
              @click="onShowSelectDevice('WAIT_MONITOR_APPROVE')"
            >
              GS duyệt
            </b-button> -->
            <b-button
              class="ml-2"
              variant="primary"
              @click="$router.push({ path: '/kpi-record/upload/add' })"
            >
              Tải lại file
            </b-button>
            <b-button
              class="ml-2"
              variant="primary"
              @click="$router.push({ path: '/file/detail/' + kpiData.fileId })"
            >
              Chi tiết upload file
            </b-button>
            <b-button class="ml-2" @click="$router.push({ name: 'kpi record upload history' })">
              Quay lại
            </b-button>
          </div>
        </div>
        <!-- content -->
        <div class="d-flex justify-content-between">
          <div class="row w-100">
            <div class="col-sm-6">
              <div class="row my-3">
                <div class="col-6">Loại dịch vụ</div>
                <div class="col-6">
                  {{ Config.getText(kpiData.serviceType, this.serviceType) }}
                </div>
              </div>
              <div class="row my-3">
                <div class="col-6">Vùng</div>
                <div class="col-6">{{ kpiData.regionName }}</div>
              </div>
              <div class="row my-3">
                <div class="col-6">Tên file tải lên</div>
                <div class="col-6">{{ kpiData.filename }}</div>
              </div>
              <div class="row my-3">
                <div class="col-6">Ghi chú</div>
                <div class="col-6">{{ kpiData.note }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="mt-3" v-if="sseData != 'SUCCESS'">
          <div class="d-flex justify-content-between align-items-center">
            <div>Tiến độ upload file</div>
          </div>
        </div>
        <div
          v-if="sseData != 'SUCCESS'"
          class="my-2 d-flex justify-content-between align-items-end"
        >
          <div class="shell">
            <div class="bar" :style="{ width: sseData + '%' }">
              <span class="span" v-if="sseData >= 5">{{ sseData }}%</span>
            </div>
          </div>
        </div>
        <!-- table -->
        <div v-if="sseData === 'SUCCESS'">
          <div class="my-2 d-flex justify-content-between align-items-end">
            <div class="">Tổng: {{ pagination.total }} KPI</div>
          </div>
          <b-table
            :fields="fieldsTable"
            responsive
            hover
            sticky-header
            :fixed="true"
            :bordered="true"
            style="max-height: calc(100vh - 100px)"
            :busy.sync="tbLoading"
            :items="lists"
            show-empty
            empty-text="Không có dữ liệu!"
          >
            <template #table-busy>
              <div class="text-center my-2">
                <b-spinner class="align-middle"></b-spinner>
              </div>
            </template>
            <template #cell(index)="data">
              {{ data.index + 1 }}
            </template>
            <template #cell(packageType)="data">
              <p v-if="data.item.packageType">Loại gói: {{ data.item.packageType }}</p>
              <p v-if="data.item.duration">Thời hạn: {{ data.item.duration }}</p>
            </template>
            <template #cell(status)="data">
              <span class="badge" :class="data.item.status">
                {{ data.item.status | transformData(Config.statusDeviceKpi) }}
              </span>
            </template>

            <template #cell(action)="data">
              <template v-if="data.item.status === 'NEW'">
                <b-button
                  size="sm"
                  variant="primary"
                  v-if="canDeviceKpiUpdateMx"
                  @click="changeDevices(data.item, data.item.serviceType)"
                  class="mr-2"
                  >Sửa
                </b-button>
                <b-button
                  size="sm"
                  variant="danger"
                  v-if="canDeviceKpiCancelMx"
                  @click="deleteDevice(data.item)"
                  >Xoá
                </b-button>
              </template>
            </template>
          </b-table>
          <div class="d-flex justify-content-end">
            <b-pagination
              v-model="search.page"
              :total-rows="pagination.total"
              :per-page="search.limit"
              class="fl-right mr-2"
            ></b-pagination>
          </div>
          <ModalEditDevice
            v-model="showModalDevice"
            @submit="submitFormDevice"
            :dataEdit="deviceData"
            :serviceType="serviceType"
          ></ModalEditDevice>
        </div>
      </div>
    </div>
    <ModalSelectDevice
      v-if="showSelectDevice"
      v-model="showSelectDevice"
      :statusKpi="statusKpi"
      @submit="onSubmitListDevice"
      :kpiFileUploadId="search.kpiFileUploadId"
      :creatorId="creatorId"
      :actionModalSelectDevice="actionModalSelectDevice"
    ></ModalSelectDevice>
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"> </VueLoadingOverlay>
  </div>
</template>

<script>
  import kpiRecordMx from './kpiRecordMx'
  import Config from '@/thirdParty/config'
  // import { StaffService } from '@/services/staff.service'
  import { DeviceService } from '../../services/device.service'
  import ModalSelectDevice from './components/ModalSelectDevice.vue'
  import { getUrl } from '../../services/customer-support'

  export default {
    components: { ModalSelectDevice },
    mixins: [kpiRecordMx],
    data() {
      return {
        Config,
        deviceData: {},
        serviceType: '',
        showModalDevice: false,
        showLoading: false,
        tbLoading: false,
        formData: {},
        dataUser: JSON.parse(localStorage.getItem('userData')),
        kpiData: {},
        sseData: null,

        // table
        lists: [],
        pagination: {
          total: 0,
        },
        search: {
          limit: 20,
          page: 1,
          kpiFileUploadId: this.$route.params.id,
        },
        fieldsTable: [
          { key: 'index', label: 'STT', class: 'text-center' },
          { key: 'merchantEmail', label: 'Email MC', thStyle: '' },
          { key: 'contractCode', label: 'Mã hợp đồng', thStyle: '' },
          { key: 'appendixCode', label: 'Mã phụ lục', thStyle: '' },
          { key: 'service', label: 'Dịch vụ', thStyle: '' },
          { key: 'packageType', label: 'Loại gói & Thời hạn' },
          { key: 'categoryName', label: 'Tên TB', thStyle: '' },
          { key: 'serial', label: 'Serial TB', thStyle: '' },
          { key: 'receiptCode', label: 'Mã phiếu thu', thStyle: '' },
          { key: 'transactionCode', label: 'Mã giao dịch', thStyle: '' },
          { key: 'month', label: 'Tháng tính KPI' },
          { key: 'kpi', label: 'Số KPI' },
          { key: 'emailSale', label: 'Email CVKD', thStyle: '' },
          { key: 'status', label: 'Trạng thái', thStyle: '' },
          { key: 'note', label: 'Ghi chú', thStyle: '' },
          {
            key: 'action',
            label: 'Thao tác',
            fixIndex: 999,
            class: 'text-center',
            thStyle: 'min-width: 100px',
          },
        ],
        serviceType: [
          { id: 'PAYMENT', text: 'Thanh toán' },
          { id: 'SELL', text: 'Bán hàng' },
        ],

        showSelectDevice: false,
        statusKpi: '',
        creatorId: null,
      }
    },
    created() {
      this.fetchData()
    },
    watch: {
      'search.page': function () {
        this.fetchListKpi()
      },
      sseData(newSseData) {
        if (newSseData !== 'SUCCESS') {
          window.addEventListener('beforeunload', this.showCustomAlert)
        } else {
          window.removeEventListener('beforeunload', this.showCustomAlert)
        }
      },
    },
    methods: {
      async fetchData() {
        this.fetchOrderKpiDeital()
        this.fetchListKpi()
      },
      async fetchOrderKpiDeital() {
        try {
          this.showLoading = true
          const params = {
            id: this.$route.params.id,
          }
          const response = await DeviceService.orderKpiDeital(params)
          if (response.code === 1000) {
            console.log(response)
            this.kpiData = response.data
            this.readFile(response.data.fileId, this.dataUser.token)
          } else {
            throw new Error(response.message)
          }
        } catch (error) {
          console.log(error)
          this.showFailMx(error.message ?? error)
        } finally {
          this.showLoading = false
        }
      },
      async fetchListKpi() {
        try {
          this.tbLoading = true
          const params = {
            ...this.search,
          }
          const response = await DeviceService.deviceKpiGetList(params)
          if (response.code === 1000) {
            this.lists = response.data.kpiAggregateRes
            this.pagination.total = response.data.count
          } else {
            throw new Error(response.message)
          }
        } catch (error) {
          console.log(error)
          this.showFailMx(error.message ?? error)
        } finally {
          this.tbLoading = false
        }
      },
      onShowSelectDevice(status, creatorId = null, actionModalSelectDevice = null) {
        if (!status) return
        this.statusKpi = status
        this.creatorId = creatorId
        this.actionModalSelectDevice = actionModalSelectDevice
        this.showSelectDevice = true
      },
      async onSubmitListDevice(ids, status, action) {
        // Hủy
        if (action === 'DELETE' && status === 'NEW') {
          const data = await this.deviceKpiCancelMx(ids)
          if (data) {
            this.showSelectDevice = false
          }
          return
        }

        // gửi duyệt NEW
        if (status === 'NEW') {
          const data = await this.deviceKpiSendApproveMx(ids)
          if (data) {
            this.showSelectDevice = false
          }
          return
        }

        // dám sát duyệt WAIT_MONITOR_APPROVE
        if (status === 'WAIT_MONITOR_APPROVE') {
          const data = await this.deviceKpiMonitorApproveMx(ids)
          if (data) {
            this.showSelectDevice = false
          }
        }
      },

      async deleteDevice(device) {
        if (device.status !== 'NEW') {
          this.showFailMx('Không thể sửa thông tin thiết bị')
          return
        }
        this.deviceKpiCancelMx([device.id])
      },
      changeDevices(device, serviceType) {
        console.log({ device, serviceType })
        if (!device || !serviceType) {
          this.showFailMx('Không có đủ thông tin thiết bi')
          return
        }
        if (device.status !== 'NEW') {
          this.showFailMx('Không thể sửa thông tin thiết bị')
          return
        }

        this.serviceType = serviceType
        this.deviceData = device ? { ...device } : null
        this.showModalDevice = true
      },
      async submitFormDevice({ data, serviceType }) {
        const isDone = await this.deviceKpiUpdateMx({ ...data, serviceType })
        if (isDone) {
          this.showSuccessMx('Đã cập nhập thiết bị thành công')
          this.showModalDevice = false
        }
      },
      async readFile(id, bearerToken) {
        try {
          const sseClient = await fetch(`${getUrl('cnps.summary.file.read')}?id=${id}`, {
            headers: {
              Authorization: bearerToken,
              Accept: 'text/event-stream',
            },
          })
          if (!sseClient.ok) {
            throw Error(sseClient.statusText())
          }

          for (const reader = sseClient.body.getReader(); ; ) {
            const { value, done } = await reader.read()
            if (done) {
              break
            }
            const chunk = new TextDecoder().decode(value)
            const payload = String(chunk).replace(/^data:/, '')
            if (payload.includes('SUCCESS')) {
              this.sseData = 'SUCCESS'
            } else this.sseData = Number(payload)
          }
          this.fetchListKpi()
        } catch (error) {
          console.log(error)
        }
      },
      showCustomAlert(event) {
        const customMessage = 'Bạn có thay đổi chưa được lưu. Bạn có chắc chắn muốn rời khỏi trang?'
        event.returnValue = customMessage
        alert(customMessage)
      },
    },
  }
</script>

<style scoped>
  @import './commonStyles.css';
  .shell {
    height: 27px;
    width: 500px;
    border: 1px solid #aaa;
    border-radius: 13px;
    padding: 3px;
  }

  .bar {
    background: linear-gradient(to right, #b993d6, #8ca6db);
    height: 20px;
    width: 15px;
    border-radius: 9px;
  }
  .span {
    float: right;
    padding: 4px 5px;
    color: #fff;
    font-size: 0.9em;
  }
</style>
